import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
export const showContactsByDataPoints = (searchData) => __awaiter(void 0, void 0, void 0, function* () { return yield AjaxUtils.post('/api' + '/v5/show', searchData); });
